import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Card } from "reactstrap";
import Content from "../../layout/content/Content";
import UserProfileAside from "../pre-built/user-manage/UserProfileAside";

const CustomerAdminLayout = () => {
  const [sm, updateSm] = useState(false);
  const [mobileView, setMobileView] = useState(false);

  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      updateSm(false);
    }
  };

  useEffect(() => {
    viewChange();
    window.addEventListener("resize", viewChange);
    return () => window.removeEventListener("resize", viewChange);
  }, []);

  return (
    <Content>
      <Card className="card-bordered">
        <div className="card-aside-wrap">
          <div
            className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
              sm ? "content-active" : ""
            }`}
          >
            <UserProfileAside updateSm={updateSm} sm={sm} />
          </div>
          <div className="card-inner card-inner-lg">
            {sm && mobileView && (
              <div className="toggle-overlay" onClick={() => updateSm(!sm)}></div>
            )}
            <Outlet context={{ sm, updateSm }} />
          </div>
        </div>
      </Card>
    </Content>
  );
};

export default CustomerAdminLayout;
